import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  to: string;
}

interface DownloadButton {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbItem[];
  downloadButton?: DownloadButton;
  buttons?: DownloadButton[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  breadcrumbs,
  downloadButton,
  buttons,
}) => {
  const allButtons = buttons || (downloadButton ? [downloadButton] : []);

  return (
    <div className="breadcrumbs-section">
      <div className="breadcrumbs">
        {breadcrumbs.map((breadcrumb, index) => (
          <span key={breadcrumb.to}>
            <Link to={breadcrumb.to} className="breadcrumb-link">
              {breadcrumb.label}
            </Link>
            {index < breadcrumbs.length - 1 && (
              <span className="breadcrumb-separator"> › </span>
            )}
          </span>
        ))}
      </div>
      {allButtons.length > 0 && (
        <div style={{ display: "flex", gap: "10px" }}>
          {allButtons.map((btn, index) => (
            <button
              key={index}
              onClick={btn.onClick}
              className="download-btn"
              disabled={btn.disabled}
              style={{
                backgroundColor: btn.disabled ? "#ccc" : "#28a745",
                opacity: btn.disabled ? 0.5 : 1,
              }}
            >
              {btn.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Breadcrumbs;
